//imports
import {
	GENERAL_SEARCH_TAGS_REQUEST,
	GENERAL_SEARCH_TAGS_RESULT,
	GENERAL_SEARCH_MANUFACTURERS_REQUEST,
	GENERAL_SEARCH_MANUFACTURERS_RESULT,
	GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST,
	GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_RESULT,
	GENERAL_SEARCH_SIM_PROVIDERS_REQUEST,
	GENERAL_SEARCH_SIM_PROVIDERS_RESULT,
	GENERAL_SEARCH_DEVICE_MODELS_REQUEST,
	GENERAL_SEARCH_DEVICE_MODELS_RESULT,
	GENERAL_SEARCH_ENTITY_REQUEST,
	GENERAL_SEARCH_ENTITY_RESULT,
	GENERAL_SEARCH_DEALERS_REQUEST,
	GENERAL_SEARCH_DEALERS_RESULT,
	GENERAL_SEARCH_TIMEZONES_REQUEST,
	GENERAL_SEARCH_TIMEZONES_RESULT,
	GENERAL_SAVE_AUDIT_LOG,
	GENERAL_SAVE_AUDIT_LOG_RESULT,
	GENERAL_GENERIC_EXPORT_SEND_RESULT,
	GENERAL_COUNT_PEDING_NOTIFICATIONS,
	GENERAL_COUNT_PEDING_NOTIFICATIONS_RESULT,
	GENERAL_SEARCH_NOTIFICATIONS,
	GENERAL_SEARCH_NOTIFICATIONS_RESULT,
	GENERAL_UPDATE_NOTIFICATION,
	GENERAL_UPDATE_NOTIFICATION_RESULT,
	GENERAL_SET_CREATE_NOTIFICATION_ID,
	GENERAL_SET_TOTAL_RECORDS,
	GENERAL_EXPORT,
	GENERAL_CATALOG_INITIAL,
	GENERAL_CATALOG_INITIAL_RESULT,
	GENERAL_DOWNLOAD_REPORT_FILE_REQUEST,
	GENERAL_DOWNLOAD_REPORT_FILE_RESULT,
	GENERAL_EXPORT_PENDING_ADD,
	GENERAL_EXPORT_PENDING_COMPLETE,
	GENERAL_EXPORT_PENDING_REMOVE,
	CLEAR_REDUX,
} from 'Redux/actionTypes';

import * as processors from '../processors'
import { sub } from 'date-fns';

//initial values
const INIT_STATE = {
	tags: [],
	tagLoading: false,

	manufacturers: [],
	manufacturersLoading: false,

	simProviderAccounts: [],
	simProviderAccountsLoading: false,

	simProviders: [],
	simProvidersLoading: false,

	deviceModels: [],
	deviceModelsLoading: false,

	loadingEntity: false,

	dealers: [],
	dealersLoading: false,

	timeZonesLoading: false,
	timeZones: [],

	pulsCustomersLoading: false,
	pulsCustomers: [],

	firmwaresLoading: false,
	firmwares: [],

	saveAuditLogsResult: null,
	saveAuditLogsResultLoading: false,
	exportResult: null,

	pmUsersLoading: false,
	pmUsers: [],

	unitTypesLoading: false,
	unitTypes: [],

	smsIntegrationsLoading: false,
	smsIntegrations: [],

	countPendingNotifications: 0,
	loadingCountPendingNotifications: false,

	notifications: [],
	loadingNotifications: false,
	notificationsNextToken: null,

	updateNotificationResult: null,
	loadingUpdateNotification: false,
	alertTypes: [],
	loadingAlerttypes: false,
	ctcAccounts: [],

	keyFobModelsLoading: false,
	keyFobModels: [],

	eventsLoading: false,
	events: [],

	integrations: [],
	loadingIntegrations: false,

	export: false,
	totalRecords: 0,
	createNotificationId: null,

	accounts: [],
	loadingAccount: false,

	units: [],
	loadingUnits: false,

	brands: [],

	sources: [],
	loadingSources: false,

	downloadReportFileResult: null,

	pendingExports: [],

	subUsers: []
};

//change redux object
export default (state = INIT_STATE, action) => {

	let objResult;
	const processInitialItems = (type, items, oldItems) => {
		let processor = processors[type]
		if (processor) {
			let processorObj = new processor()
			const [result, itemsProcessed] = processorObj.executeArray(items, oldItems)

			if (result)
				return itemsProcessed


			return {}
		}
	}

	switch (action.type) {

		case GENERAL_SEARCH_TAGS_REQUEST:
			return { ...state, tagLoading: true };

		case GENERAL_SEARCH_TAGS_RESULT:
			return { ...state, tagLoading: false, tags: action.payload?.items || [] };

		case GENERAL_SEARCH_MANUFACTURERS_REQUEST:
			return { ...state, manufacturersLoading: true };

		case GENERAL_SEARCH_MANUFACTURERS_RESULT:
			return { ...state, manufacturersLoading: false, manufacturers: action.payload?.items || [] };

		case GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST:
			return { ...state, simProviderAccountsLoading: true };

		case GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_RESULT:
			return { ...state, simProviderAccountsLoading: false, simProviderAccounts: action.payload?.items || [] };

		case GENERAL_SEARCH_SIM_PROVIDERS_REQUEST:
			return { ...state, simProvidersLoading: true };

		case GENERAL_SEARCH_SIM_PROVIDERS_RESULT:
			return { ...state, simProvidersLoading: false, simProviders: action.payload?.items || [] };

		case GENERAL_SEARCH_DEVICE_MODELS_REQUEST:
			return { ...state, deviceModelsLoading: true };

		case GENERAL_SEARCH_DEVICE_MODELS_RESULT:
			return { ...state, deviceModelsLoading: false, deviceModels: action.payload?.items || [] };


		case GENERAL_SEARCH_ENTITY_REQUEST:
			return { ...state, loadingEntity: true };

		case GENERAL_SEARCH_ENTITY_RESULT:
			switch (action?.payload?.key) {
				case "tags":
					return { ...state, loadingEntity: false, tags: action.payload?.items || [] };
				case "manufacturers":
					let items = action.payload?.items || [];
					let activeManufactuers = items.filter(x => x.active === true);
					return { ...state, loadingEntity: false, manufacturers: activeManufactuers || [] };
				case "deviceModels":
					return { ...state, loadingEntity: false, deviceModels: action.payload?.items || [] };
				case "simProviderAccounts":
					return { ...state, loadingEntity: false, simProviderAccounts: action.payload?.items || [] };
				case "simProviders":
					return { ...state, loadingEntity: false, simProviders: action.payload?.items || [] };
				case "pulsCustomers":
					let plsCustomers = Object.values(action.payload)
					if (plsCustomers.length === 1 && plsCustomers[0] === "pulsCustomers")
						plsCustomers = [];
					return { ...state, loadingEntity: false, pulsCustomers: plsCustomers };
				case "firmwares":
					return { ...state, loadingEntity: false, firmwares: action.payload?.items || [] };
				case "pmUsers":
					return { ...state, loadingEntity: false, pmUsers: action.payload?.items || [] };
				case "unitTypes":
					return { ...state, loadingEntity: false, unitTypes: action.payload?.items || [] };
				case "timezones":
					return { ...state, loadingEntity: false, timeZones: action.payload?.items || [] };
				case "smsIntegrations":
					return { ...state, loadingEntity: false, smsIntegrations: action.payload?.items || [] };
				case "dealers":
					return { ...state, loadingEntity: false, dealers: action.payload?.items || [] };
				case "alertTypes":
					return { ...state, loadingEntity: false, alertTypes: action.payload?.items || [] };
				case "ctcAccounts":
					return { ...state, loadingEntity: false, ctcAccounts: action.payload.data || [] };
				case "keyFobModels":
					return { ...state, loadingEntity: false, keyFobModels: action.payload?.items || [] };
				case "events":
					return { ...state, loadingEntity: false, events: action.payload?.data || [] };
				case "integrations":
					return { ...state, loadingEntity: false, integrations: action.payload?.items || [] };
				case "accounts":
					return { ...state, loadingEntity: false, accounts: action.payload?.items || [] };
				case "units":
					return { ...state, loadingEntity: false, units: action.payload?.items || [] }
				case "brands":
					return { ...state, loadingEntity: false, brands: action.payload?.items || [] }
				case "subUsers":
					return { ...state, loadingEntity: false, subUsers: action.payload?.items || [] }
				case "sources":
					return { ...state, loadingEntity: false, sources: action.payload?.items || [] }
				default:
					return { ...state, loadingEntity: false };
			}

		case GENERAL_SEARCH_DEALERS_REQUEST:
			return { ...state, dealersLoading: true }

		case GENERAL_SEARCH_DEALERS_RESULT:
			return { ...state, dealersLoading: false, dealers: action.payload }

		case GENERAL_SEARCH_TIMEZONES_REQUEST:
			return { ...state, timeZonesLoading: true }

		case GENERAL_SEARCH_TIMEZONES_RESULT:
			return { ...state, timeZonesLoading: false, timeZones: action.payload }

		case GENERAL_SAVE_AUDIT_LOG:
			return { ...state, saveAuditLogsResultLoading: true }

		case GENERAL_SAVE_AUDIT_LOG_RESULT:
			return { ...state, saveAuditLogsResultLoading: false, saveAuditLogsResult: action.payload }

		case GENERAL_GENERIC_EXPORT_SEND_RESULT:
			return { ...state, exportResult: action.payload }

		case GENERAL_COUNT_PEDING_NOTIFICATIONS:
			return { ...state, loadingCountPendingNotifications: true }

		case GENERAL_COUNT_PEDING_NOTIFICATIONS_RESULT:
			return { ...state, loadingCountPendingNotifications: false, countPendingNotifications: action?.payload?.count }

		case GENERAL_SEARCH_NOTIFICATIONS:
			return { ...state, loadingNotifications: true }

		case GENERAL_SEARCH_NOTIFICATIONS_RESULT:
			return {
				...state,
				loadingNotifications: false,
				notifications: [...state.notifications, ...action?.payload?.items],
				notificationsNextToken: action?.payload?.nextToken
			}

		case GENERAL_UPDATE_NOTIFICATION:
			return { ...state, loadingUpdateNotification: true }

		case GENERAL_UPDATE_NOTIFICATION_RESULT:
			return { ...state, loadingUpdateNotification: false, updateNotificationResult: action.payload }

		case GENERAL_EXPORT:
			return { ...state, export: action.payload }

		case GENERAL_SET_TOTAL_RECORDS:
			return { ...state, totalRecords: action.payload }

		case GENERAL_SET_CREATE_NOTIFICATION_ID:
			return { ...state, createNotificationId: action.payload }

		case GENERAL_CATALOG_INITIAL:
			//console.log(state)
			return { ...state, loadingUnits: true, loadingReadings: true, loadingTags: true };

		case GENERAL_CATALOG_INITIAL_RESULT:
			let objUpdate = action.payload;
			objResult = { ...state, ...objUpdate }
			//console.log(objResult)
			/*if (state.temp_units && state.temp_units.length > 0) {
			  objResult = processInitialItems("units", state.temp_units, action.payload || [])
			  objUpdate = { ...objUpdate, ...objResult, units_temp: [] }
			}*/

			let units = processInitialItems("Unit", objUpdate.units, objResult)
			objResult = { ...objResult, ...units }

			let readings = processInitialItems("LastReading", objUpdate.readings, objResult)
			objResult = { ...objResult, ...readings }

			// let pmDevices = processInitialItems("pmDevices", objUpdate.pmDevices, objResult)
			// objResult = { ...objResult, ...pmDevices }

			let vehiclesInformation = processInitialItems("VehicleInformation", objUpdate.vehiclesInformation, objResult)
			objResult = { ...objResult, ...vehiclesInformation }

			let unitTags = processInitialItems("UnitTags", objUpdate.unitTags, objResult);

			objResult = { ...objResult, ...unitTags };

			//return { ...state, loadingUnits: true, loadingReadings: true, loadingVehiclesInformation: true };
			return { ...state, ...objResult };
		case GENERAL_DOWNLOAD_REPORT_FILE_REQUEST:
			return { ...state, downloadReportFileResult: null }
		case GENERAL_DOWNLOAD_REPORT_FILE_RESULT:
			return { ...state, downloadReportFileResult: action.payload }

		case GENERAL_EXPORT_PENDING_ADD: {
			const currentPendingAdd = Array.isArray(state.pendingExports) ? state.pendingExports : [];
			return {
				...state,
				pendingExports: [...currentPendingAdd, { ...action.payload, status: 'pending', startedAt: Date.now() }]
			};
		}

		case GENERAL_EXPORT_PENDING_COMPLETE: {
			const { url } = action.payload;
			const urlStr = Array.isArray(url) ? (url[0]?.url || '') : (url || '');
			// try to match by export name in URL, fall back to oldest pending
			let matched = false;

			const updated = state?.pendingExports?.map(exp => {
				if (!matched && exp.status === 'pending' && exp.name && urlStr.toLowerCase().includes(exp.name.toLowerCase())) {
					matched = true;
					return { ...exp, status: 'complete', url, completedAt: Date.now() };
				}
				return exp;
			});

			if (!matched && updated) {
				const firstPendingIdx = updated.findIndex(exp => exp.status === 'pending')
				if (firstPendingIdx >= 0) updated[firstPendingIdx] = { ...updated[firstPendingIdx], status: 'complete', url, completedAt: Date.now() };
			}
			return { ...state, pendingExports: updated };
		}

		case GENERAL_EXPORT_PENDING_REMOVE:
			return { ...state, pendingExports: state?.pendingExports?.filter(exp => exp.id !== action.payload) };

		case CLEAR_REDUX:
			return ["", "GENERAL"].includes(action.payload.option)
				? action.payload.parameters
					? { ...state, ...action.payload.parameters }
					: { ...INIT_STATE }
				: { ...state };

		default:
			return state;
	}
};
